import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

var getCorvusProviderName = function getCorvusProviderName(context) {
  var locale = context.locale || context.state.i18n.currentLocale;
  var $cookies = context.$cookies;
  var international = {
    'fr-FR': true,
    'es-ES': false,
    'nl-BE': false,
    'fr-BE': false,
    'de-DE': false,
    'it-IT': false,
    'fr-LU': false,
    'nl-NL': false,
    'de-AT': false,
    'pt-PT': false,
    'de-CH': false,
    'it-CH': false,
    'fr-CH': false,
    'en-GB': false
  };
  return $cookies.get('MDM_SEARCH_PROVIDERS_CORVUS') && international[locale.iso] && !$cookies.get('algolia') ? 'algolia' : 'elastic';
};

export default getCorvusProviderName;